module.exports = __webpack_public_path__ + "img/folder-tree.ee710308.svg";